import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

if (process.env.NODE_ENV === 'test') {
  const logger = queryClient.getLogger()
  logger.error = () => null
}
